import {
  typography,
  palette,
  Box,
  styled,
  Typography,
  theme,
  Theme,
  Icon,
} from '@yuno/design-system-web'
import banner from '../../assets/ilustracion_banner.png'
import deleteBanner from '../../assets/delete_banner.svg'

export const BannerTitle = styled('span')(() => ({
  ...typography.small.bold,
  color: `${palette.neutral.white['0']}`,
}))

export const BannerParagraph = styled('div')(() => ({
  ...typography.small.regular,
  color: `${palette.neutral.white['0']}`,
  margin: '10px 0 20px 0',
  '& a': {
    color: `${palette.vivid.sunset}`,
    textDecoration: 'none',
  },
}))

export const BannerLink = styled('a')(() => ({
  ...typography.base.bold,
  color: `${palette.vivid.sunset}`,
  cursor: 'pointer',
  textDecoration: 'underline',
}))

export const BannerImage = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  padding: '24px',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '4px',
  backgroundColor: theme.palette.background.paper,
  marginBottom: 40,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPositionX: 'right',
  mb: (props) => props.marginBottom || 0,
  [theme.breakpoints.up(1250)]: {
    backgroundImage: `url(${banner})`,
  },
}))

export const BannerText = styled(Typography)<{
  type: 'title' | 'body'
  theme?: Theme
}>(({ type, theme }) => ({
  fontSize: type === 'title' ? '16px' : '12px',
  fontWeight: type === 'title' ? 700 : 400,
  lineHeight: type === 'title' ? '24px' : '16px',
  marginBottom: type === 'title' ? '8px' : 0,

  '& a.doc-link': {
    fontSize: theme.typography.small.bold.fontSize,
    fontWeight: theme.typography.small.bold.fontWeight,
    color: theme.palette.vivid.brand,
    marginTop: 8,
    display: 'inline-block',
  },

  '& a': {
    textDecoration: 'none',
    color: theme.palette.vivid.brand,
  },
}))

export const CounterSpan = styled('span')(({ theme }: { theme?: Theme }) => ({
  borderRadius: '16px',
  color: theme.palette.grey['5'],
  backgroundColor: theme.palette.grey['2'],
  fontSize: theme.typography.tiny.regular.fontSize,
  padding: '0px 6px',
}))

export const Close = styled(Box)(() => ({
  position: 'absolute',
  top: 8,
  right: 16,
  cursor: 'pointer',
  width: '25px',
  height: '25px',
  backgroundImage: `url(${deleteBanner})`,
}))

export const TitleStyled = styled('span')(
  ({ theme }: { children: string; theme?: Theme }) => ({
    ...theme.typography['2xl'].bold,
    color: theme.palette.neutral.black,
    fontSize: '34px',
  }),
)

export const WrapperTitle = styled('div')(() => ({
  marginBottom: '40px',
  paddingLeft: '20px',
}))
